import { barnToolsApi } from './base';
import { IGateway, IGatewayCollection } from './types';

export const gatewayApi = barnToolsApi
  .enhanceEndpoints({ addTagTypes: ['gateways'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getGateway: builder.query<{ Gateway: IGateway }, string>({
        query: (serialNumber) => `gateways/${serialNumber}`,
        providesTags: (result) => {
          if (result) {
            return [{ type: 'gateways', id: result.Gateway.serialNumber }];
          } else {
            return ['gateways'];
          }
        },
      }),
      getAllGateways: builder.query<IGatewayCollection, void>({
        query: () => `gateways/`,
        providesTags: (result) =>
          result
            ? [
                ...result.Gateways.map(({ serialNumber }) => ({
                  type: 'gateways' as const,
                  serialNumber,
                })),
                'gateways',
              ]
            : ['gateways'],
      }),
      getGatewaysByOrg: builder.query<
        IGatewayCollection,
        {
          orgIds: string[];
          orderBy: string;
          asc: boolean;
          search: string;
          start: number;
          length: number;
        }
      >({
        query: (args: {
          orgIds: string[];
          orderBy: string;
          asc: boolean;
          search: string;
          start: number;
          length: number;
        }) => {
          const params: Record<string, string> = {};
          if (args.orgIds) {
            params.orgIds = args.orgIds.join(',');
          }
          return {
            url: `gateways/`,
            params: params,
          };
        },
        providesTags: ['gateways'],
      }),
      updateGatewayDetails: builder.mutation({
        query: (args: { gatewaySerial: string; gatewayName: string }) => {
          return {
            url: `/gateways/${args.gatewaySerial}`,
            method: 'PUT',
            body: { name: args.gatewayName },
          };
        },
        invalidatesTags: ['gateways'],
      }),
    }),
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetGatewayQuery,
  useGetAllGatewaysQuery,
  useLazyGetAllGatewaysQuery,
  useGetGatewaysByOrgQuery,
  useLazyGetGatewaysByOrgQuery,
  useUpdateGatewayDetailsMutation,
} = gatewayApi;
